import {
  FormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";

export class FormUtil {
  constructor() {}

  isFieldValid(form: UntypedFormGroup, field: string, attempt: boolean) {
    if (attempt) {
      return form.get(field).valid;
    }

    return false;
  }

  displayFieldCss(form: UntypedFormGroup, field: string, attempt: boolean) {
    if (attempt) {
      return {
        // 'form-valid': this.isFieldValid(form, field, attempt),
        "form-invalid": form.get(field).invalid,
      };
    }

    return {};
  }

  validatePasswordOnly(password: string) {
    if (!password) {
      return false;
    }

    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSymbol = /[-!@$%^&*#()_+|~=`{}\[\]:";'<>?,.\/]/.test(password);
    const hasMinimumLength = password.length >= 8;

    return (
      hasUppercase && hasLowercase && hasNumber && hasSymbol && hasMinimumLength
    );
  }

  validatePassword = (c: UntypedFormControl) =>
    this.validatePasswordOnly(c.value)
      ? null
      : {
          validateEmail: {
            valid: false,
          },
        };

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}
